import { useEffect, useState } from "react";
import { getCurrentMailboxAddress } from "../taskpane";
import { useMailboxIntegrations } from "./useMailboxIntegrations";

export const useCurrentMailbox = () => {
  const [currentEmailAddress, setCurrentEmailAddress] = useState<string>("");
  const { mailboxIntegrations } = useMailboxIntegrations();
  useEffect(() => {
    getCurrentMailboxAddress().then(setCurrentEmailAddress);
  }, []);

  const currentMailboxId = mailboxIntegrations?.mailboxIntegrations?.find((integration) =>
    integration.sharedMailboxes.some((shared) => shared.email === currentEmailAddress)
  )?.id;

  return {
    currentEmailAddress: currentEmailAddress ?? "",
    currentMailboxId,
    isMailboxConnected: Boolean(currentMailboxId),
  };
};
